import { ref } from "vue";
import global from "@/global";

export function useFetchAnswer({ uri, headers, skipAutoFetch = true }) {
  const fetchedData = ref(null);
  const fetchError = ref(null);
  const queryParam = ref("");

  const fetchData = async () => {
    try {
      const res = await fetch(`${global.API_URL}${uri}${queryParam.value}`, {
        method: "GET",
        headers: headers,
      });

      fetchedData.value = await res.json();
    } catch (err) {
      fetchError.value = err;
    }
  };

  !skipAutoFetch && fetchData();

  return { fetchData, fetchedData, fetchError, queryParam };
}
